import { Controller } from '@hotwired/stimulus';
import { noop } from 'lodash';

/* global $, Mn, toastr, Cifra */
const AcuseReciboRespuesta = Mn.View.extend({
  template: noop,
  events: {
    'submit form.acuse-recibo-respuesta': 'responder',
  },
  // eslint-disable-next-line object-shorthand
  responder: function (e) {
    e.preventDefault();
    const $form = $(e.currentTarget);
    $.post(
      $form.attr('action'), $form.serialize(), undefined, 'json',
    ).done((data) => {
      if (data.error) {
        toastr.error(data.error);
      } else {
        const textArea = $form.find('textarea');

        textArea.animateCss('pulse', () => {
          textArea.attr('readonly', '');
        });
        $form.find(':submit').fadeOut(Cifra.Conf.ANIMATION_SPEED);
      }
    });
  },
});

export default class extends Controller {
  connect() {
    new AcuseReciboRespuesta({ el: this.element }).render();
  }
}
